import { useSignature } from 'legacy/lut/hooks/useSignature'
import { useCallback } from 'react'

export const useFinSobDropSignature = () => {
  const { dropSignature, signatureId } = useSignature()

  const isNeedToShowSignDialog = Boolean(signatureId)

  const dropFinSignature = useCallback(async () => {
    await dropSignature('Financial & SOB Targets')
  }, [dropSignature])

  return {
    dropFinSignature,
    isNeedToShowSignDialog,
  }
}
